/**
 * RectangularButton component background color options.
 * Treat this file as an enum.
 * @module rectangularButtonColorOptions
 * @category Buttons
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * White color
 * @type {string}
 */
export const WHITE = "white";

/**
 * Blue color
 * @type {string}
 */
export const BLUE = "blue";

/**
 * Green color
 * @type {string}
 */
export const GREEN = "green";

/**
 * Orange color
 * @type {string}
 */
export const ORANGE = "orange";

/**
 * Red color
 * @type {string}
 */
export const RED = "red";
